import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { getO2NewSkin, ThemeConfig, ThemeContextProvider } from '@telefonica/mistica';
import '@telefonica/mistica/css/mistica.css';
import { Provider } from 'react-redux';
import { store } from './utils/store/store';
import { BrowserRouter as Router } from 'react-router-dom';
import GlobalLoader from './components/GlobalLoader/GlobalLoader';
import GlobalError from './components/GlobalError/GlobalError';
import GlobalSnackbar from './components/GlobalSnackbar/GlobalSnackbar';
import GlobalStopper from './components/GlobalStopper/GlobalStopper';
import GlobalSnackbarProfile from './components/GlobalSnackbarProfile/GlobalSnackbarProfile';
import BillsProvider from './context/bills-context/BillsProvider';
import ConfigureLineProvider from './context/configure-line-context/ConfigureLineProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import PersonalDataProvider from './context/personal-data-context/PersonalDataProvider';
import MobileLinesProvider from './context/mobile-lines-context/MobileLinesProvider';
import { setupEnvironmentProxy } from './utils/dataTransformation/environments';
import ReactDOM from 'react-dom/client';
import DevicesProvider from './context/devices-context/DevicesProvider';
import ChangeOwnershipProvider from './context/change-ownership-context/ChangeOwnershipProvider';
import { GlobalContext } from './context/global-context/GlobalContext';
import EscalationProvider from './context/escalation-context/EscalationProvider';

setupEnvironmentProxy();
const LOCALE = 'es-ES';
const LOCALE_REGION = 'ES';
const misticaTheme: ThemeConfig = {
    skin: getO2NewSkin(),
    colorScheme: 'light',
    i18n: { locale: LOCALE, phoneNumberFormattingRegionCode: LOCALE_REGION },
};
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            gcTime: 900000,
            staleTime: 300000,
            refetchOnWindowFocus: false,
            retry: 0,
        },
    },
});

root.render(
    <ThemeContextProvider theme={misticaTheme}>
        <Provider store={store}>
            <Router>
                <GlobalError />
                <GlobalLoader />
                <GlobalStopper />
                <GlobalContext>
                    <EscalationProvider>
                        <QueryClientProvider client={queryClient}>
                            <MobileLinesProvider>
                                <DevicesProvider>
                                    <PersonalDataProvider>
                                        <ChangeOwnershipProvider>
                                            <ConfigureLineProvider>
                                                <BillsProvider>
                                                    <App />
                                                    <GlobalSnackbar />
                                                    <GlobalSnackbarProfile />
                                                </BillsProvider>
                                            </ConfigureLineProvider>
                                        </ChangeOwnershipProvider>
                                    </PersonalDataProvider>
                                </DevicesProvider>
                            </MobileLinesProvider>
                        </QueryClientProvider>
                    </EscalationProvider>
                </GlobalContext>
            </Router>
        </Provider>
    </ThemeContextProvider>,
);

reportWebVitals();
